import api from './axiosInstance';

export const subscriptionApi = {
  // Public plan catalog (no auth required, but axios adds token anyway - fine)
  listPlans: () => api.get('/saas/plans'),
  getPlanDetail: (id) => api.get(`/saas/plans/${id}`),
  listAddons: () => api.get('/saas/plans/addons'),

  // Subscription lifecycle
  subscribe: (orgUnitId, data) =>
    api.post(`/subscriptions/org-units/${orgUnitId}/subscribe`, data),
  startTrial: (orgUnitId) => api.post(`/subscriptions/org-units/${orgUnitId}/trial`),
  activateSubscription: (orgUnitId, data) =>
    api.post(`/subscriptions/org-units/${orgUnitId}/activate`, data),
  renewSubscription: (subscriptionId, data) =>
    api.post(`/subscriptions/${subscriptionId}/renew`, data),
  suspendSubscription: (subscriptionId, reason) =>
    api.post(`/subscriptions/${subscriptionId}/suspend`, null, {params: {reason}}),
  getActiveSubscription: (orgUnitId) =>
    api.get(`/subscriptions/org-units/${orgUnitId}/active`),
  getSubscriptionHistory: (orgUnitId) =>
    api.get(`/subscriptions/org-units/${orgUnitId}/history`),
  getEvents: (subscriptionId) => api.get(`/subscriptions/${subscriptionId}/events`),

  // Invoices
  listInvoices: () => api.get('/saas-invoices'),
  getInvoiceDetail: (id) => api.get(`/saas-invoices/${id}`),
  markInvoicePaid: (id) => api.post(`/saas-invoices/${id}/pay`),
};
